import { defaultProps } from '../../../../app/browser/analyticsDefaultProperties';

export default {
  identify: {},
  page: {},
  elements: {
    'welcome-modal--ok-button': {
      click: {
        name: 'Item Clicked',
        properties: {
          ...defaultProps,
          description: 'Welcome Modal Got It',
          activityLocation: 'SP : Home',
          serviceProviderId: '<<attributes.data-track-spid.value>>',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/welcomeModalAnalytics.js